import { ReactComponent as WarningIcon } from "../../assets/icons/warning.svg";
import { useAppSelector } from "../../store/hooks";
import violationStyles from "../../styles/UI/violation.module.css";
import { Violation } from "../../types/ganttChart";
import labels from "../../utils/labels";
import {
  getViolationMessagesFromViolationName,
  resolveEmployeeNames,
} from "../../utils/violationUtils";

const ViolationBox = ({
  violations,
  violationOnUnplannedTask,
}: {
  violations: Violation[];
  violationOnUnplannedTask?: boolean;
}) => {
  const employees =
    useAppSelector(
      (state) => state.ganttChartSlice.ganttChartData?.employees,
    ) ?? [];

  const getViolationMessage = (violation: Violation): string => {
    if (violation.name === "RESTRICTED_EMPLOYEE") {
      const names = violation.employeeRefs
        ? resolveEmployeeNames(violation.employeeRefs, employees)
        : labels.restrictedEmployeeFallbackName;
      return labels.violationRestrictedEmployee(names);
    }
    return getViolationMessagesFromViolationName(violation.name);
  };

  const uniqueViolationMessages: string[] = Array.from(
    new Set(violations.map(getViolationMessage)),
  );

  return (
    <div className={violationStyles.violationBox}>
      <div className="pt-[3px]">
        <WarningIcon width={14} height={14} />
      </div>
      <ul className={violationStyles.violationBoxList}>
        {uniqueViolationMessages.map((message) => (
          <li key={message} className={violationStyles.violationBoxListItem}>
            <div className="flex gap-[var(--spacing-xs)]">
              <h4 className={violationStyles.violationBoxTitle}>
                {" "}
                {violationOnUnplannedTask
                  ? labels.unplannedTask
                  : labels.violation}
              </h4>
              {message}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ViolationBox;
